/* eslint-disable max-lines */
export const authTypes = {
  AUTHENTICATE: 'AUTHENTICATE',
  DEAUTHENTICATE: 'DEAUTHENTICATE',
  ME: 'ME',
  FOLLOWED_GOALS: 'FOLLOWED_GOALS',
  DAILY_TASK: 'DAILY_TASK',
  FETCH_COUNTRIES: 'FETCH_COUNTRIES',
  FETCH_STATES: 'FETCH_STATES',
  FETCH_CREDENTIALS: 'FETCH_CREDENTIALS',
  FETCH_BIO_RECOMMENDATION: 'FETCH_BIO_RECOMMENDATION',
  SELECTED_GOAL: 'SELECTED_GOAL',
  SELECTED_NAV: 'SELECTED_NAV',
  SHOW_FOLLOW_GOAL_TOOLTIP: 'SHOW_FOLLOW_GOAL_TOOLTIP',
  SHOW_SWITCH_GOAL_TOOLTIP: 'SHOW_SWITCH_GOAL_TOOLTIP',
  FOLLOW_GOAL: 'FOLLOW_GOAL',
  RESEND_OTP: 'RESEND_OTP',
  LOGIN: 'LOGIN',
  RESET_OTP_RESPONSE: 'RESET_OTP_RESPONSE',
  LOGIN_MODAL: 'LOGIN_MODAL',
  VERIFY_PHONE: 'VERIFY_PHONE',
  VERIFY_OTP: 'VERIFY_OTP',
  RESET_VERIFY_OTP_RESPONSE: 'RESET_VERIFY_OTP_RESPONSE',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_CREDENTIALS: 'UPDATE_CREDENTIALS',
  UNLOCK_FREE_PLAN: 'UNLOCK_FREE_PLAN',
  RESET_NETWORK_CALLS_ERROR: 'RESET_NETWORK_CALLS_ERROR',
  SEND_MAIL_OTP: 'SEND_MAIL_OTP',
  VERIFY_MAIL_OTP: 'VERIFY_MAIL_OTP',
  SEND_MOBILE_OTP: 'SEND_MOBILE_OTP',
  VERIFY_MOBILE_OTP: 'VERIFY_MOBILE_OTP',
  HIDE_NUDGE: 'HIDE_NUDGE',
  FETCH_FEEDBACK_OPTIONS: 'FETCH_FEEDBACK_OPTIONS',
  SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
  TOGGLE_DARK_MODE: 'TOGGLE_DARK_MODE',
  SET_DARK_MODE: 'SET_DARK_MODE',
  LATEST_STREAK: 'LATEST_STREAK',
  UPDATE_AVATAR: 'UPDATE_AVATAR',
  FETCH_RENEWAL_TOUCHPOINT_DATA: 'FETCH_RENEWAL_TOUCHPOINT_DATA',
  FETCH_SETTINGS_MANAGE_UPDATES: 'FETCH_SETTINGS_MANAGE_UPDATES',
  FETCH_REFERRAL_DETAILS: 'FETCH_REFERRAL_DETAILS',
  FETCH_REFERRAL_LIST: 'FETCH_REFERRAL_LIST',
  CHANGE_MANAGE_UPDATE_PREFERENCES: 'CHANGE_MANAGE_UPDATE_PREFERENCES',
  FETCH_INTERCOM_TOKEN: 'FETCH_INTERCOM_TOKEN',
  ME_ACCESS_CONTROL: 'ME_ACCESS_CONTROL',
  PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS: 'PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS',
  HIDE_REFERRAL_BANNER: 'HIDE_REFERRAL_BANNER',
  GENERATE_CUSTOM_CODE: 'GENERATE_CUSTOM_CODE',
  GET_CUSTOM_CODE_DATA: 'GET_CUSTOM_CODE_DATA'
};

export const courseTypes = {
  UPDATE_COURSES: 'UPDATE_COURSES',
  UPDATE_FEEDROWS: 'UPDATE_FEEDROWS',
  FETCH_FREE_COURSES: 'FETCH_FREE_COURSES',
  FETCH_FREE_GOAL_COURSES: 'FETCH_FREE_GOAL_COURSES',
  FETCH_COURSE_INFO: 'FETCH_COURSE_INFO',
  FETCH_SPECIAL_CLASSES: 'FETCH_SPECIAL_CLASSES',
  FETCH_SPECIAL_CLASSES_TYPE: 'FETCH_SPECIAL_CLASSES_TYPE',
  FETCH_FREE_CONTINUE_LEARNING: 'FETCH_CONTINUE_LEARNING',
  FETCH_MY_LIBRARY: 'FETCH_MY_LIBRARY',
  TOGGLE_COURSE_SAVED: 'TOGGLE_COURSE_SAVED',
  FETCH_ENROLLED_COURSES: 'FETCH_ENROLLED_COURSES',
  FETCH_RECOMMENDED_COURSES: 'FETCH_RECOMMENDED_COURSES',
  FETCH_COMPLETED_COURSES: 'FETCH_COMPLETED_COURSES',
  FETCH_MORE_COURSES: 'FETCH_MORE_COURSES',
  FETCH_MORE_COURSES_FILTERS: 'FETCH_MORE_COURSES_FILTERS',
  FETCH_ENROLLED_COURSES_FILTERS: 'FETCH_ENROLLED_COURSES_FILTERS',
  FETCH_SEE_ALL_FEED: 'FETCH_SEE_ALL_FEED',
  TOGGLE_COURSE_ENROLLED: 'TOGGLE_COURSE_ENROLLED',
  FETCH_FREE_COURSE_ITEM: 'FETCH_FREE_COURSE_ITEM',
  FETCH_RELEVANT_COURSES: 'FETCH_RELEVANT_COURSES',
  FETCH_COURSE_REVIEWS: 'FETCH_COURSE_REVIEWS',
  SUBMIT_REVIEW: 'SUBMIT_REVIEW',
  FETCH_FREE_COURSES_OF_A_GOAL: 'FETCH_FREE_COURSES_OF_A_GOAL',
  FETCH_ONBOARDING_RECOMMENDED_COURSES: 'FETCH_ONBOARDING_RECOMMENDED_COURSES',
  FETCH_PREVIOUS_ENROLLED_COURSES: 'FETCH_PREVIOUS_ENROLLED_COURSES',
  TOGGLE_LIKE: 'TOGGLE_LIKE',
  ADD_COMMENT: 'ADD_COMMENT',
  FETCH_COMMENTS: 'FETCH_COMMENTS',
  INCREASE_COMMENT: 'INCREASE_COMMENT',
  TOGGLE_COMMENT_LIKE: 'TOGGLE_COMMENT_LIKE',
  ADD_REPLY: 'ADD_REPLY',
  FETCH_FILTERS: 'FETCH_FILTERS',
  UPDATE_FILTER: 'UPDATE_FILTER',
  CHECK_COURSE_ENROLL: 'CHECK_COURSE_ENROLL'
};

export const educatorTypes = {
  UPDATE_USERS: 'UPDATE_USERS',
  FETCH_EDUCATOR_LEADERBOARD: 'FETCH_EDUCATOR_LEADERBOARD',
  FETCH_PROFILE_INFO: 'FETCH_PROFILE_INFO',
  FETCH_PROFILE_STATS: 'FETCH_PROFILE_STATS',
  FETCH_PROFILE_FEED: 'FETCH_PROFILE_FEED',
  FETCH_FILTERED_COURSES: 'FETCH_FILTERED_COURSES',
  FETCH_EDUCATOR_COURSES_FILTERS: 'FETCH_EDUCATOR_COURSES_FILTERS',
  FETCH_EDUCATOR_TESTIMONIALS: 'FETCH_EDUCATOR_TESTIMONIALS',
  TOGGLE_FOLLOWING_STATUS: 'TOGGLE_FOLLOWING_STATUS',
  FETCH_LEARNER_COURSES: 'FETCH_LEARNER_COURSES',
  FETCH_LEARNER_MILESTONES: 'FETCH_LEARNER_MILESTONES',
  FETCH_LEARNER_FOLLOWING_LIST: 'FETCH_LEARNER_FOLLOWING_LIST',
  FETCH_LEARNER_LEADERBOARD_GOALS: 'FETCH_LEARNER_LEADERBOARD_GOALS',
  FETCH_LEARNER_LEADERBOARD: 'FETCH_LEARNER_LEADERBOARD',
  FETCH_MY_RANKS: 'FETCH_MY_RANKS',
  FETCH_DAILY_TASK_HISTORY: 'FETCH_DAILY_TASK_HISTORY',
  FETCH_USER_STATS: 'FETCH_USER_STATS',
  FETCH_FAVOURITE_EDUCATORS: 'FETCH_FAVOURITE_EDUCATORS',
  WRITE_DEDICATION: 'WRITE_DEDICATION',
  SELECTED_NAV_EDU: 'SELECTED_NAV_EDU',
  FETCH_EDUCATOR_DASHBOARD_COURSES: 'FETCH_EDUCATOR_DASHBOARD_COURSES',
  FETCH_EDUCATOR_SCHEDULED_CLASSES: 'FETCH_EDUCATOR_SCHEDULED_CLASSES',
  UPDATE_COURSE_DETAILS: 'UPDATE_COURSE_DETAILS',
  UPDATE_COURSE_DROPDOWN_FIELDS: 'UPDATE_COURSE_DROPDOWN_FIELDS',
  FETCH_ALL_LANGUAGES: 'FETCH_ALL_LANGUAGES',
  SEARCH_GOAL: 'SEARCH_GOAL',
  UPDATE_COURSE_AUTOCOMPLETE_FIELDS: 'UPDATE_COURSE_AUTOCOMPLETE_FIELDS',
  SEARCH_TOPIC: 'SEARCH_TOPIC',
  SEARCH_EXAM: 'SEARCH_EXAM',
  SEARCH_EDUCATOR: 'SEARCH_EDUCATOR',
  CREATE_PLUS_COURSE: 'CREATE_PLUS_COURSE',
  EDIT_PLUS_COURSE: 'EDIT_PLUS_COURSE',
  REMOVE_TAG: 'REMOVE_TAG',
  UPDATE_CHECK_BOX: 'UPDATE_CHECK_BOX',
  CREATE_SPECIAL_CLASS: 'CREATE_SPECIAL_CLASS',
  EDIT_SPECIAL_CLASS: 'EDIT_SPECIAL_CLASS',
  UPLOAD_THUMBNAIL: 'UPLOAD_THUMBNAIL',
  FETCH_COURSE_TYPES: 'FETCH_COURSE_TYPES',
  SET_COURSE_TYPE: 'SET_COURSE_TYPE',
  FETCH_SPECIAL_CLASS_DETAILS: 'FETCH_SPECIAL_CLASS_DETAILS',
  SEACRH_CONCEPT: 'SEACRH_CONCEPT',
  UPDATE_SESSION_VALUE: 'UPDATE_SESSION_VALUE',
  UPDATE_SESSION_CONCEPTS: 'UPDATE_SESSION_CONCEPTS',
  REMOVE_CONCEPT: 'REMOVE_CONCEPT',
  FETCH_CO_AUTHOR: 'FETCH_CO_AUTHOR',
  ADD_ITEM: 'ADD_ITEM',
  EDIT_SESSION: 'EDIT_SESSION',
  DELETE_ITEM: 'DELETE_ITEM',
  SET_SESSION_EDUCATOR: 'SET_SESSION_EDUCATOR',
  SETUP_EDIT_SESSION: 'SETUP_EDIT_SESSION',
  CREATE_TEST_SERIES_COURSE: 'CREATE_TEST_SERIES_COURSE',
  EDIT_TEST_SERIES_COURSE: 'EDIT_TEST_SERIES_COURSE',
  STATE_CHANGE: 'STATE_CHANGE',
  FETCH_EDUCATOR_DEDICATIONS: 'FETCH_EDUCATOR_DEDICATIONS',
  FETCH_EDUCATOR_WATCH_MINUTES: 'FETCH_EDUCATOR_WATCH_MINUTES',
  FETCH_EDUCATOR_VIEWS_STATS: 'FETCH_EDUCATOR_VIEWS_STATS',
  FETCH_EDUCATOR_ALERTS: 'FETCH_EDUCATOR_ALERTS',
  FETCH_EDUCATOR_REFERRALS: 'FETCH_EDUCATOR_REFERRALS',
  FETCH_EDUCATOR_LIVE_HOURS: 'FETCH_EDUCATOR_LIVE_HOURS',
  FETCH_EDUCATOR_STATISTICS: 'FETCH_EDUCATOR_STATISTICS',
  FETCH_EDUCATOR_LIVE_CLASSES: 'FETCH_EDUCATOR_LIVE_CLASSES',
  SET_CREATE_EDIT_SESSION_ERROR_FLAG: 'SET_CREATE_EDIT_SESSION_ERROR_FLAG',
  CLEAR_ADD_ITEM_FORM: 'CLEAR_ADD_ITEM_FORM',
  CLEAR_COURSE_FIELDS: 'CLEAR_COURSE_FIELDS',
  FETCH_EDU_LIVE_CLASS_URL: 'FETCH_EDU_LIVE_CLASS_URL',
  FETCH_COURSE_STATS: 'FETCH_COURSE_STATS',
  FETCH_COURSE_RATINGS: 'FETCH_COURSE_RATINGS',
  FETCH_COURSE_FEEDBACK: 'FETCH_COURSE_FEEDBACK',
  FETCH_LESSON_METRICS: 'FETCH_LESSON_METRICS',
  FETCH_EDU_LESSON_FEEDBACK: 'FETCH_EDU_LESSON_FEEDBACK',
  UPDATE_RESCHEDULE_TEXT_FIELD: 'UPDATE_RESCHEDULE_TEXT_FIELD',
  UPDATE_RESCHEDULE_DROPDOWN_FIELDS: 'UPDATE_RESCHEDULE_DROPDOWN_FIELDS',
  RESCHEDULE_CLASS: 'RESCHEDULE_CLASS',
  FETCH_COURSE_DETAILS: 'FETCH_COURSE_DETAILS',
  UPDATE_DISCUSSION_FORUM_TEXT: 'UPDATE_DISCUSSION_FORUM_TEXT',
  UPDATE_DISCUSSION_FORUM_STORY: 'UPDATE_DISCUSSION_FORUM_STORY',
  SET_FILTER: 'SET_FILTER',
  FETCH_GOLIVE_DETAILS: 'FETCH_GOLIVE_DETAILS',
  FETCH_TEMPLATES_OF_A_COURSE: 'FETCH_TEMPLATES_OF_A_COURSE',
  UPDATE_TEMPLATES: 'UPDATE_TEMPLATES',
  FETCH_TEMPLATE_DETAILS: 'FETCH_TEMPLATE_DETAILS',
  SEARCH_TOPIC_GROUP: 'SEARCH_TOPIC_GROUP',
  ADD_TEMPLATE_LESSON: 'ADD_TEMPLATE_LESSON',
  SETUP_TEMPLATE_EDIT_SESSION: 'SETUP_TEMPLATE_EDIT_SESSION',
  SAVE_TEMPLATE: 'SAVE_TEMPLATE',
  DELETE_TEMPLATE_LESSONS: 'DELETE_TEMPLATE_LESSON',
  FETCH_COURSE_TEMPLATE_FILTERS: 'FETCH_COURSE_TEMPLATE_FILTERS',
  SETUP_TEMPLATE_DATA_FOR_COURSE: 'SETUP_TEMPLATE_DATA_FOR_COURSE',
  ADD_TEMPLATE_COURSE: 'ADD_TEMPLATE_COURSE',
  EDIT_TEMPLATE_COURSE: 'EDIT_TEMPLATE_COURSE',
  UPDATE_TEMPLATE_COURSE_FIELDS: 'UPDATE_TEMPLATE_COURSE_FIELDS',
  UPDATE_SCHEDULE_WEEK_DAY: 'UPDATE_SCHEDULE_WEEK_DAY',
  FETCH_TEMPLATE_COURSE_DETAILS: 'FETCH_TEMPLATE_COURSE_DETAILS',
  SET_SCHEDULE_OF_TEMPLATE_COURSE: 'SET_SCHEDULE_OF_TEMPLATE_COURSE',
  SETUP_TEMPLATE_DATA_IN_EDU_COURSE: 'SETUP_TEMPLATE_DATA_IN_EDU_COURSE',
  EDIT_TEMPLATE_COURSE_LESSON_WITHOUT_UID:
    'EDIT_TEMPLATE_COURSE_LESSON_WITHOUT_UID',
  FILL_DURATION_IN_SCHEDULE: 'FILL_DURATION_IN_SCHEDULE',
  DELETE_COURSE_TEMPLATE: 'DELETE_COURSE_TEMPLATE',
  CLEAR_TEMPLATE_SESSION: 'CLEAR_TEMPLATE_SESSION',
  SET_TEMPLATE_LESSON_DURATION: 'SET_TEMPLATE_LESSON_DURATION',
  CLEAR_TEMPLATE_DATA: 'CLEAR_TEMPLATE_DATA',
  DELETE_TEMPLATE_LESSONS_FROM_COURSE: 'DELETE_TEMPLATE_LESSONS_FROM_COURSE',
  GET_FEEDBACK_FOR_COURSE_TEMPLATE: 'GET_FEEDBACK_FOR_COURSE_TEMPLATE',
  SUBMIT_FEEDBACK_FOR_COURSE_TEMPLATE: 'SUBMIT_FEEDBACK_FOR_COURSE_TEMPLATE',
  SET_CLASH_SESSIONS_OF_A_COURSE: 'SET_CLASH_SESSIONS_OF_A_COURSE',
  SET_LESSON_REFS: 'SET_LESSON_REFS',
  SET_DRAG_INFO: 'SET_DRAG_INFO',
  SET_TEMPLATE_REORDERED_QUIZ_LESSONS: 'SET_TEMPLATE_REORDERED_QUIZ_LESSONS',
  GET_FEEDBACK_FOR_EDUCATOR_DASHBOARD: 'GET_FEEDBACK_FOR_EDUCATOR_DASHBOARD',
  SUBMIT_FEEDBACK_FOR_EDUCATOR_DASHBOARD:
    'SUBMIT_FEEDBACK_FOR_EDUCATOR_DASHBOARD',
  CLEAR_COURSE_UID: 'CLEAR_COURSE_UID',
  REMOVE_CLASH_SESSIONS: 'REMOVE_CLASH_SESSIONS',
  FETCH_CONTENT_SLIDE_LANGUAGES: 'FETCH_CONTENT_SLIDE_LANGUAGES',
  GET_ON_BOARDING_PREFERENCES: 'GET_ON_BOARDING_PREFERENCES',
  CREATE_LIVE_SUPPORT_TICKET: 'CREATE_LIVE_SUPPORT_TICKET'
};

export const educatorOnboardingTypes = {
  GET_EDU_ONBOARD_FORM_STATUS: 'GET_EDU_ONBOARD_FORM_STATUS',
  GET_EDU_ONBOARD_FORM_DETAILS: 'GET_EDU_ONBOARD_FORM_DETAILS',
  GET_EDU_ONBOARD_FORM_USER_RESPONSE: 'GET_EDU_ONBOARD_FORM_USER_RESPONSE',
  SUBMIT_EDU_ONBOARD_FORM_USER_RESPONSE:
    'SUBMIT_EDU_ONBOARD_FORM_USER_RESPONSE',
  SET_EDU_ONBOARD_FORM_COVERED_STATE: 'SET_EDU_ONBOARD_FORM_COVERED_STATE',
  SET_EDU_ONBOARD_FORM_VIEW_STATE: 'SET_EDU_ONBOARD_FORM_VIEW_STATE',
  GET_LATEST_RECORDING_DETAILS: 'GET_LATEST_RECORDING_DETAILS',
  SET_EDU_ONBOARD_FORM_STATUS: 'SET_EDU_ONBOARD_FORM_STATUS',
  DELETE_ROOM: 'DELETE_ROOM'
};

export const topologyTypes = {
  UPDATE_TOPOLOGIES: 'UPDATE_TOPOLOGIES',
  FETCH_ONBOARDING_GOALS: 'FETCH_ONBOARDING_GOALS',
  FETCH_GOAL_LANGUAGES: 'FETCH_GOAL_LANGUAGES',
  SET_GOAL_LANGUAGE: 'SET_GOAL_LANGUAGE',
  FETCH_TOPOLOGY_FEED: 'FETCH_TOPOLOGY_FEED',
  FETCH_NOTES: 'FETCH_NOTES',
  FETCH_TOPOLOGY_CHILDREN: 'FETCH_TOPOLOGY_CHILDREN',
  FETCH_TOPOLOGY_INFO: 'FETCH_TOPOLOGY_INFO',
  FETCH_TOPOLOGY_COURSE_FEED: 'FETCH_TOPOLOGY_COURSE_FEED',
  FETCH_TOPOLOGY_COURSES: 'FETCH_TOPOLOGY_COURSES',
  FETCH_TOPOLOGY_EXTRA_INFO: 'FETCH_TOPOLOGY_EXTRA_INFO',
  FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE:
    'FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE',
  FETCH_TOPOLOGY_OF_FREE_COURSE_FEED: 'FETCH_TOPOLOGY_OF_FREE_COURSE_FEED',
  FETCH_FREE_COURSES_OF_A_CONCEPT: 'FETCH_FREE_COURSES_OF_A_CONCEPT',
  FETCH_POPULAR_GOALS: 'FETCH_POPULAR_GOALS',
  FETCH_COURSE_STATS: 'FETCH_COURSE_STATS',
  FETCH_PRESUBSCRIBED_STATIC_CONTENT: 'FETCH_PRESUBSCRIBED_STATIC_CONTENT',
  FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES:
    'FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES',
  SAVE_PREFERENCE_FETCH_NEXT: 'SAVE_PREFERENCE_FETCH_NEXT',
  FETCH_ALL_ONBOARDING_PREFERENCE_OF_A_USER:
    'FETCH_ALL_ONBOARDING_PREFERENCE_OF_A_USER',
  HIDE_ONBOARDING_PREFERECE_NUDGE: 'HIDE_ONBOARDING_PREFERECE_NUDGE',
  UPDATE_GLO_STATUS: 'UPDATE_GLO_STATUS',
  FETCH_SUBSCRIPTION_GOALS: 'FETCH_SUBSCRIPTION_GOALS'
};

export const combatTypes = {
  FETCH_CONTEST_INFO: 'FETCH_CONTEST_INFO',
  FETCH_CONTEST_RATING: 'FETCH_CONTEST_RATING',
  FETCH_MY_RATING: 'FETCH_MY_RATING',
  FETCH_UPCOMING_COMBATS_INFO: 'FETCH_UPCOMING_COMBATS_INFO',
  FETCH_COMBAT_DETAILS: 'FETCH_COMBAT_DETAILS',
  FETCH_CONTEST_ONBOARDING_PREFERENCES: 'FETCH_CONTEST_ONBOARDING_PREFERENCES',
  ENROLL_FOR_CONTEST: 'ENROLL_FOR_CONTEST',
  UPDATE_CONTEST_ONBOARDING_PREFERENCES: 'UPDATE_CONTEST_ONBOARDING_PREFERENCES'
};

export const plusCoursesTypes = {
  FETCH_TEST_SERIES: 'FETCH_TEST_SERIES',
  FETCH_PLUS_HOME_FEED: 'FETCH_PLUS_HOME_FEED',
  FETCH_EBINFO_PLUS_HOME_FEED: 'FETCH_EBINFO_PLUS_HOME_FEED',
  FETCH_SEE_ALL_EBINFO: 'FETCH_SEE_ALL_EBINFO',
  FETCH_SIMILAR: 'FETCH_SIMILAR',
  FETCH_NEXT_TRACK: 'FETCH_NEXT_TRACK',
  FETCH_COURSE_UPDATES: 'FETCH_COURSE_UPDATES'
};

export const itemTypes = {
  UPDATE_ITEMS: 'UPDATE_ITEMS',
  FETCH_WATCH_HISTORY: 'FETCH_WATCH_HISTORY',
  FETCH_FREE_LESSON_INFO: 'FETCH_FREE_LESSON_INFO',
  FETCH_FREE_LESSON_LIST: 'FETCH_FREE_LESSON_LIST',
  BOOKMARK_ITEM: 'BOOKMARK_ITEM'
};

export const classTypes = {
  FETCH_CLASS: 'FETCH_CLASS',
  FETCH_SIMILAR_AND_OTHER_COURSES: 'FETCH_SIMILAR_AND_OTHER_COURSES',
  SEND_WATCHED: 'SEND_WATCHED',
  SEND_WATCHED_PREVIOUS: 'SEND_WATCHED_PREVIOUS',
  LIVE_CLASS_FEEDBACK: 'LIVE_CLASS_FEEDBACK',
  UPDATE_PAGEVIEW: 'UPDATE_PAGEVIEW',
  FETCH_SCHEDULED_CLASSES: 'FETCH_SCHEDULED_CLASSES',
  FETCH_CALENDAR_DATA: 'FETCH_CALENDAR_DATA'
};

export const subscriptionTypes = {
  FETCH_PRICINGS: 'FETCH_PRICINGS',
  VALIDATE_REFERRAL: 'VALIDATE_REFERRAL',
  VALIDATE_REFERRAL_WITH_SUBSCRIPTION_ID:
    'VALIDATE_REFERRAL_WITH_SUBSCRIPTION_ID',
  VALIDATE_REFERRAL_SUBSCRIPTION: 'VALIDATE_REFERRAL_SUBSCRIPTION',
  CLEAR_REFERRAL_ERROR: 'CLEAR_REFERRAL_ERROR',
  CLEAR_REFERRAL_PRICINGS: 'CLEAR_REFERRAL_PRICINGS',
  CLEAR_REFERRAL_SUBSCRIPTION: 'CLEAR_REFERRAL_SUBSCRIPTION',
  FETCH_PAYMENT_METHODS: 'FETCH_PAYMENT_METHODS',
  FETCH_SAVED_CARDS: 'FETCH_SAVED_CARDS',
  FETCH_EMI_PLANS: 'FETCH_EMI_PLANS',
  FETCH_PART_PAYMENT_STATUS: 'FETCH_PART_PAYMENT_STATUS',
  ENROLL_ORDER: 'ENROLL_ORDER',
  ENROLL_INSTALLMENT_ORDER: 'ENROLL_INSTALLMENT_ORDER',
  CLEAR_ORDER: 'CLEAR_ORDER',
  CANCEL_ENROLL_ORDER: 'CANCEL_ENROLL_ORDER',
  PURCHASE_SUBSCRIPTION: 'PURCHASE_SUBSCRIPTION',
  PAYMENT_STATUS_JUSPAY: 'PAYMENT_STATUS_JUSPAY',
  SAVE_PURCHASED_SUBSCRIPTION: 'SAVE_PURCHASED_SUBSCRIPTION',
  ACTIVATE_EXTERNAL_APP: 'ACTIVATE_EXTERNAL_APP',
  FETCH_PART_PAYMENTS_INFOS: 'FETCH_PART_PAYMENTS_INFOS',
  FETCH_PART_PAYMENTS_FAQS: 'FETCH_PART_PAYMENTS_FAQS',
  STOP_PART_PAYMENT_NUDGE: 'STOP_PART_PAYMENT_NUDGE',
  HIDE_PART_PAYMENT_NUDGE: 'HIDE_PART_PAYMENT_NUDGE',
  SYNC_CODE_CHEF: 'SYNC_CODE_CHEF',
  FETCH_LOAN_LEARNER_DETAILS: 'FETCH_LOAN_LEARNER_DETAILS',
  FETCH_ELIGIBLE_GOALS: 'FETCH_ELIGIBLE_GOALS',
  SUBMIT_LOAN_DATA: 'SUBMIT_LOAN_DATA',
  SUBMIT_CASH_DEPOSIT_DATA: 'SUBMIT_CASH_DEPOSIT_DATA',
  FETCH_ELIGIBLE_SUBSCRIPTIONS: 'FETCH_ELIGIBLE_SUBSCRIPTIONS',
  FETCH_ELIGIBLE_SUBSCRIPTIONS_FOR_CASH_PAYMENT:
    'FETCH_ELIGIBLE_SUBSCRIPTIONS_FOR_CASH_PAYMENT',
  VALIDATE_CASH_REFERRAL: 'VALIDATE_CASH_REFERRAL',
  FETCH_SUBSCRIPTION_STATIC_DATA: 'FETCH_SUBSCRIPTION_STATIC_DATA',
  FETCH_BUNDLE_DETAILS: 'FETCH_BUNDLE_DETAILS',
  FETCH_COMBO_FEATURE_POINTS: 'FETCH_COMBO_FEATURE_POINTS',
  VERIFY_VPA: 'VERIFY_VPA',
  FETCH_UPI_SUFFIX_LIST: 'FETCH_UPI_SUFFIX_LIST',
  VERIFY_DC_EMI_ELIGIBILITY: 'VERIFY_DC_EMI_ELIGIBILITY',
  FETCH_CARD_BANK_ALIASES: 'FETCH_CARD_BANK_ALIASES',
  FETCH_ALL_PAYMENT_METHODS: 'FETCH_ALL_PAYMENT_METHODS',
  FETCH_CASH_PAYMENT_DATA: 'FETCH_CASH_PAYMENT_DATA',
  CANCEL_CASH_PAYMENT: 'CANCEL_CASH_PAYMENT',
  RESET_CASH_RESPONSE: 'RESET_CASH_RESPONSE'
};

export const specialClassTypes = {
  FETCH_EBINFO_SEE_ALL_URL: 'FETCH_EBINFO_SEE_ALL_URL',
  FETCH_SPECIAL_CLASS_SEE_ALL_BLOCK: 'FETCH_SPECIAL_CLASS_SEE_ALL_BLOCK'
};

export const notificationTypes = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  MARK_NOTIFICATION_READ: 'MARK_NOTIFICATION_READ'
};

export const searchTypes = {
  FETCH_SEARCH_RESULT: 'FETCH_SEARCH_RESULT',
  FETCH_SEARCH_LIST: 'FETCH_SEARCH_LIST',
  FETCH_POPULAR_SEARCHES: 'FETCH_POPULAR_SEARCHES',
  FETCH_AUTOCOMPLETE: 'FETCH_AUTOCOMPLETE'
};

export const otherTypes = {
  FETCH_FAQS: 'FETCH_FAQS',
  FETCH_S3_SIGNIN_URL: 'FETCH_S3_SIGNIN_URL',
  SUBMIT_ISSUE: 'SUBMIT_ISSUE',
  FETCH_LEGENDS_BANNER: 'FETCH_LEGENDS_BANNER',
  FETCH_SITEMAP: 'FETCH_SITEMAP',
  FETCH_CONSTANTS: 'FETCH_CONSTANTS',
  FETCH_ICONIC_SUBSCRIPTION_INFO: 'FETCH_ICONIC_SUBSCRIPTION_INFO',
  FETCH_SUBSCRIPTION_FEATURES: 'FETCH_SUBSCRIPTION_FEATURES',
  FETCH_SUBSCRIPTION_HIGHLIGHTS: 'FETCH_SUBSCRIPTION_HIGHLIGHTS',
  FETCH_SUBSCRIPTION_FAQS: 'FETCH_SUBSCRIPTION_FAQS',
  FETCH_PRICE_HIKE_INFO: 'FETCH_PRICE_HIKE_INFO',
  FETCH_ONE_CAROUSEL_FEED: 'FETCH_ONE_CAROUSEL_FEED',
  FETCH_ROOT_PAGE_DATA: 'FETCH_ROOT_PAGE_DATA',
  FETCH_AB_EXPERIMENT_DATA: 'FETCH_AB_EXPERIMENT_DATA'
};

export const salesTypes = {
  FETCH_CALL_ASSIST_FEED: 'FETCH_CALL_ASSIST_FEED',
  FETCH_COMBO_PLANS: 'FETCH_COMBO_PLANS',
  FETCH_PRICINGS: 'FETCH_PRICINGS',
  FETCH_AVL_PAYMENT_OPTS: 'FETCH_AVL_PAYMENT_OPTS',
  FETCH_LEAD_DETAILS: 'FETCH_LEAD_DETAILS',
  FETCH_STATS: 'FETCH_STATS',
  FETCH_CRM_GOALS: 'FETCH_CRM_GOALS',
  FETCH_SUBSCRIBED_SUBSCRIPTIONS: 'FETCH_SUBSCRIBED_SUBSCRIPTIONS',
  FETCH_FAV_EDUCATOR: 'FETCH_FAV_EDUCATOR',
  FETCH_SUGGESTED_REFFERAL: 'FETCH_SUGGESTED_REFFERAL',
  FETCH_RECOMMENDED_EDU: 'FETCH_RECOMMENDED_EDU',
  FETCH_RECOMMENDED_BATCHES: 'FETCH_RECOMMENDED_BATCHES',
  FETCH_RECOMMENDED_COURSES: 'FETCH_RECOMMENDED_COURSES',
  FETCH_RECOMMENDED_TEST_SERIES: 'FETCH_RECOMMENDED_TEST_SERIES',
  FETCH_REC_ACTIVATION_PITCH: 'FETCH_REC_ACTIVATION_PITCH'
};

export const quizTypes = {
  UPDATE_QUESTIONS: 'UPDATE_QUESTIONS',
  FETCH_QUIZ_DETAILS: 'FETCH_QUIZ_DETAILS',
  FETCH_MY_QUIZ_ATTEMPTS: 'FETCH_MY_QUIZ_ATTEMPTS',
  FETCH_QUIZ_LEADERBOARD_ALL: 'FETCH_QUIZ_LEADERBOARD_ALL',
  FETCH_QUIZ_LEADERBOARD_LIVE: 'FETCH_QUIZ_LEADERBOARD_LIVE',
  FETCH_QUIZ_RANK: 'FETCH_QUIZ_RANK',
  ENROLL_IN_QUIZ: 'ENROLL_IN_QUIZ',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  SEND_VIEWED_QUESTION: 'SEND_VIEWED_QUESTION',
  FINISH_QUIZ: 'FINISH_QUIZ',
  FINISH_SECTION: 'FINISH_SECTION',
  MARK_QUESTION: 'MARK_QUESTION',
  SUBMIT_QUESTION_RESPONSE: 'SUBMIT_QUESTION_RESPONSE',
  UPDATE_SESSION_LANGUAGE: 'UPDATE_SESSION_LANGUAGE',
  BULK_SUBMIT_ANSWERS: 'BULK_SUBMIT_ANSWERS',
  FETCH_QUESTION_REPORT_OPTIONS: 'FETCH_QUESTION_REPORT_OPTIONS',
  FETCH_QUIZ_RESULTS: 'FETCH_QUIZ_RESULTS',
  FETCH_QUIZ_DETAILED_RESULTS: 'FETCH_QUIZ_DETAILED_RESULTS',
  FETCH_SOLUTION_FILTERS: 'FETCH_SOLUTION_FILTERS',
  FETCH_PAGINATED_SOLUTIONS: 'FETCH_PAGINATED_SOLUTIONS',
  FETCH_TEST_FEEDBACK_OPTIONS: 'FETCH_TEST_FEEDBACK_OPTIONS',
  FETCH_SESSION_DETAILS: 'FETCH_SESSION_DETAILS',
  FETCH_SOLUTION_FEEDBACK_OPTIONS: 'FETCH_SOLUTION_FEEDBACK_OPTIONS',
  CHECK_ACCESS: 'CHECK_ACCESS',
  FETCH_QUIZ_DATA: 'FETCH_QUIZ_DATA',
  FETCH_SESSION_QUESTIONS: 'FETCH_SESSION_QUESTIONS',
  UPLOAD_CSV: 'UPLOAD_CSV',
  FETCH_REVIEW_STATS: 'FETCH_REVIEW_STATS',
  EDIT_QUIZ: 'EDIT_QUIZ',
  FETCH_REVIEWS: 'FETCH_REVIEWS',
  FINISH_REVIEW: 'FINISH_REVIEW',
  CREATE_UPDATE_ISSUES: 'CREATE_UPDATE_ISSUES',
  MARK_PDF_UPLOADED: 'MARK_PDF_UPLOADED',
  DELETE_SUBJECTIVE_PDF: 'DELETE_SUBJECTIVE_PDF',
  FETCH_DASHBOARD_GOALS: 'FETCH_DASHBOARD_GOALS',
  UPDATE_DASHBOARD_FILTERS: 'UPDATE_DASHBOARD_FILTERS',
  RESOLVE_ISSUES: 'RESOLVE_ISSUES',
  FETCH_REVIEW_DETAILS: 'FETCH_REVIEW_DETAILS',
  FETCH_POSTREVIEW_NOTIFICATIONS: 'FETCH_POSTREVIEW_NOTIFICATIONS',
  ASSIGN_REVIEW: 'ASSIGN_REVIEW',
  FETCH_REVIEW_NOTIFICATIONS: 'FETCH_REVIEW_NOTIFICATIONS',
  FETCH_TEST_SERIES_DATA: 'FETCH_TEST_SERIES_DATA',
  REJECT_UPLOAD_ANSWERS: 'REJECT_UPLOAD_ANSWERS',
  UPLOAD_SUJECTIVE_ANSWERS: 'UPLOAD_SUJECTIVE_ANSWERS',
  FETCH_EVALUATED_SHEET: 'FETCH_EVALUATED_SHEET',
  FETCH_EVAL_DASH_STATS: 'FETCH_EVAL_DASH_STATS',
  FETCH_MY_EVALS: 'FETCH_MY_EVALS',
  FETCH_EVALUATED_COPIES: 'FETCH_EVALUATED_COPIES',
  FETCH_EVAL_DASH_GOALS: 'FETCH_EVAL_DASH_GOALS',
  FETCH_EVAL_DETAILS: 'FETCH_EVAL_DETAILS',
  ASSIGN_EVALUATION: 'ASSIGN_EVALUATION',
  FETCH_EVAL_QUESTIONS: 'FETCH_EVAL_QUESTIONS',
  FETCH_FEEDBACK_CHOICES: 'FETCH_FEEDBACK_CHOICES',
  FETCH_EVALUATION_CRITERIA: 'FETCH_EVALUATION_CRITERIA',
  SUBMIT_EVALUATION_SCORE: 'SUBMIT_EVALUATION_SCORE',
  SKIP_EVALUATION_FEEDBACK: 'SKIP_EVALUATION_FEEDBACK',
  MARK_SKIPPED: 'MARK_SKIPPED',
  ASSIGN_MARKS: 'ASSIGN_MARKS',
  SUBMIT_SCORE: 'SUBMIT_SCORE',
  ASSIGN_EVALUATOR: 'ASSIGN_EVALUATOR',
  ASSIGN_UPLOADER: 'ASSIGN_UPLOADER',
  FETCH_MY_UPLOADS: 'FETCH_MY_UPLOADS',
  FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS: 'FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS',
  UPDATE_QUESTION_COUNT: 'UPDATE_QUESTION_COUNT',
  SET_QUESTION_COUNT: 'SET_QUESTION_COUNT',
  UPDATE_QUIZ_INSTRUCTIONS: 'UPDATE_QUIZ_INSTRUCTIONS'
};

export const preSubscribedGoal = {
  FETCH_PRESUBSCRIBED_BLOCKS: 'FETCH_PRESUBSCRIBED_BLOCKS'
};

export const playerTypes = {
  OPEN_PLAYER: 'OPEN_PLAYER',
  CLOSE_PLAYER: 'CLOSE_PLAYER',
  SET_PLAYER_DATA: 'SET_PLAYER_DATA',
  SET_PLAYER_LOADED: 'SET_PLAYER_LOADED',
  FETCH_CLASS: 'FETCH_CLASS_FOR_PLAYER',
  SET_PLAYER_URL: 'SET_PLAYER_URL',
  TOGGLE_URL_MISMATCH: 'TOGGLE_URL_MISMATCH',
  RESET_PLAYER_LOADED: 'RESET_PLAYER_LOADED',
  SET_OBJECT_TYPE: 'SET_OBJECT_TYPE',
  SET_SHOW_REFERRAL: 'SET_SHOW_REFERRAL'
};

export const batchTypes = {
  UPDATE_BATCHES: 'UPDATE_BATCHES',
  FETCH_BATCH_INFO: 'FETCH_BATCH_INFO',
  FETCH_TOPICS_COVERED: 'FETCH_TOPICS_COVERED',
  FETCH_TEST_SERIES: 'FETCH_TEST_SERIES',
  FETCH_TOPICS_WITH_CHILDREN: 'FETCH_TOPICS_WITH_CHILDREN',
  FETCH_COURSES_IN_CONCEPT: 'FETCH_COURSES_IN_CONCEPT',
  FETCH_ITEMS_IN_COURSE: 'FETCH_ITEMS_IN_COURSE',
  ENROLL_IN_BATCH: 'ENROLL_IN_BATCH',
  FETCH_SCHEDULE: 'FETCH_SCHEDULE',
  FETCH_CALENDAR_DATA: 'FETCH_CALENDAR_DATA',
  FETCH_SCHEDULED_CLASSES: 'FETCH_SCHEDULED_CLASSES',
  FETCH_BATCHES: 'FETCH_BATCHES',
  FETCH_BATCH_UPDATES: 'FETCH_BATCH_UPDATES',
  FETCH_SIMILAR_BATCHES: 'FETCH_SIMILAR_BATCHES'
};

export const classroomTypes = {
  CREATE_CLASS: 'CREATE_CLASS',
  GET_CLASS: 'GET_CLASS',
  DELETE_CLASS: 'DELETE_CLASS'
};

export const questionTypes = {
  FETCH_QUESTION_DATA: 'FETCH_QUESTION_DATA',
  FETCH_QUESTION_INFO: 'FETCH_QUESTION_INFO',
  FETCH_CONCEPT: 'FETCH_CONCEPT',
  FETCH_SUB_CONCEPTS: 'FETCH_SUB_CONCEPTS',
  TOGGLE_QUESTION_STATUS: 'TOGGLE_QUESTION_STATUS',
  EDIT_OPTION: 'EDIT_OPTION',
  SAVE_QUESTION: 'SAVE_QUESTION',
  EDIT_CONTENT: 'EDIT_CONTENT',
  EDIT_ANSWER: 'EDIT_ANSWER',
  EDIT_HINT: 'EDIT_HINT',
  EDIT_LANGUAGE: 'EDIT_LANGUAGE',
  MARK_CORRECT: 'MARK_CORRECT',
  MARK_IS_COMMON: 'MARK_IS_COMMON',
  ADD_OPTION: 'ADD_OPTION',
  REMOVE_OPTION: 'REMOVE_OPTION',
  REMOVE_LANGUAGE: 'REMOVE_LANGUAGE',
  SET_NUMBER_OPTIONS: 'SET_NUMBER_OPTIONS',
  SETUP_DATA: 'SETUP_DATA',
  FETCH_QUESTION_DATA_V2: 'FETCH_QUESTION_DATA_V2',
  SUBMIT_QUESTION_DETAILS: 'SUBMIT_QUESTION_DETAILS',
  SUBMIT_SOLUTION_RECORDING: 'SUBMIT_SOLUTION_RECORDING'
};

export const doubtTypes = {
  UPDATE_DOUBTS: 'UPDATE_DOUBTS',
  UPDATE_DOUBTSOLUTIONS: 'UPDATE_DOUBTSOLUTIONS',
  FETCH_DOUBT_DETAILS: 'FETCH_DOUBT_DETAILS',
  FETCH_SOLUTION_DETAILS: 'FETCH_SOLUTION_DETAILS',
  FETCH_MY_SOLUTIONS: 'FETCH_MY_SOLUTIONS',
  ASSIGN_DOUBT: 'ASSIGN_DOUBT',
  FETCH_CHOICES: 'FETCH_CHOICES',
  SKIP_DOUBT: 'SKIP_DOUBT',
  FETCH_STATS: 'FETCH_STATS',
  FETCH_HOME_TOPOLOGY: 'FETCH_HOME_TOPOLOGY',
  FETCH_TOPOLOGY_LIST: 'FETCH_TOPOLOGY_LIST',
  SET_HOME_TOPOLOGY: 'SET_HOME_TOPOLOGY',
  UPDATE_DOUBT_PROPS: 'UPDATE_DOUBT_PROPS',
  SUBMIT_SOLUTION: 'SUBMIT_SOLUTION',
  FEEDBACK_TO_LEARNER: 'FEEDBACK_TO_LEARNER',
  UNASSIGN_DOUBT: 'UNASSIGN_DOUBT',
  START_RECORDING: 'START_RECORDING',
  FETCH_CAMPAIGN_RULES: 'FETCH_CAMPAIGN_RULES',
  FETCH_CYCLE_EARNINGS: 'FETCH_CYCLE_EARNINGS',
  FETCH_INCENTIVE_RULES: 'FETCH_INCENTIVE_RULES'
};

export const moderatorTypes = {
  FETCH_EDUCATORS: 'FETCH_EDUCATORS',
  EDIT_ACCESS: 'EDIT_ACCESS',
  FETCH_COURSES: 'FETCH_COURSES',
  FETCH_LESSONS: 'FETCH_LESSONS',
  FETCH_POST: 'FETCH_POST'
};

export const summitTypes = {
  FETCH_EVENTS_INFO: 'FETCH_EVENTS_INFO',
  REGISTER: 'REGISTER',
  CHECK_REGISTER: 'CHECK_REGISTER',
  FETCH_SCHEDULE: 'FETCH_SCHEDULE',
  FETCH_CONTENT: 'FETCH_CONTENT'
};

export const savedTypes = {
  FETCH_SAVED_COUNT: 'FETCH_SAVED_COUNT',
  FETCH_SAVED_ENTITY: 'FETCH_SAVED_ENTITY',
  REMOVE_SAVED_ENTITY: 'REMOVE_SAVED_ENTITY',
  SAVE_ENTITY: 'SAVE_ENTITY'
};

export const helpCenterTypes = {
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  FETCH_ARTICLES: 'FETCH_ARTICLES',
  FETCH_ARTICLE_INFO: 'FETCH_ARTICLE_INFO',
  FETCH_TICKETS_HISTORY: 'FETCH_TICKETS_HISTORY',
  FETCH_ME_DATA: 'FETCH_ME_DATA',
  ON_CHAT_OPEN: 'ON_CHAT_OPEN'
};

export const analytics = {
  ANALYTICS: 'ANALYTICS'
};

export const templatesTypes = {
  FETCH_TEMPLATES: 'FETCH_TEMPLATES',
  FETCH_TEMPLATE: 'FETCH_TEMPLATE',
  RESET_TEMPLATE_FORM: 'RESET_TEMPLATE_FORM',
  FETCH_GOAL_TEMPLATES: 'FETCH_GOAL_TEMPLATES',
  UPDATE_TEMPLATE_SETTINGS: 'UPDATE_TEMPLATE_SETTINGS',
  UPDATE_TEMPLATE_DETAILS: 'UPDATE_TEMPLATE_DETAILS',
  UPDATE_TEMPLATE_EVALUATION_CRITERIA: 'UPDATE_TEMPLATE_EVALUATION_CRITERIA',
  ADD_OR_UPDATE_TEMPLATE_SECTION: 'ADD_OR_UPDATE_TEMPLATE_SECTION',
  UPDATE_TEMPLATE_INSTRUCTIONS: 'UPDATE_TEMPLATE_INSTRUCTIONS',
  SET_TEMPLATE_ERRORS: 'SET_TEMPLATE_ERRORS',
  DELETE_TEMPLATE: 'DELETE_TEMPLATE',
  UPDATE_OR_CREATE_TEMPLATE: 'UPDATE_OR_CREATE_TEMPLATE',
  CREATE_TEST_FOR_TEMPLATE: 'CREATE_TEST_FOR_TEMPLATE',
  FETCH_TEST_TEMPLATE_DETAILS: 'FETCH_TEST_TEMPLATE_DETAILS',
  CREATE_QUIZ_IN_TEMPLATE: 'CREATE_QUIZ_IN_TEMPLATE',
  EDIT_QUIZ_IN_TEMPLATE: 'EDIT_QUIZ_IN_TEMPLATE',
  FETCH_TEST_STATE: 'FETCH_TEST_STATE',
  CLEAR_TEMPLATE_FIELDS: 'CLEAR_TEMPLATE_FIELDS',
  UPDATE_EDUCATOR_SLIDES: 'UPDATE_EDUCATOR_SLIDES'
};

export const helperTypes = {
  SET_PLATFORM: 'SET_PLATFORM',
  SET_CAMPAIGN: 'SET_CAMPAIGN'
};

export const driveTypes = {
  FETCH_DRIVE_CONTENT: 'FETCH_DRIVE_CONTENT',
  CREATE_FOLDER: 'CREATE_FOLDER',
  DELETE_DRIVE_ITEM: 'DELETE_DRIVE_ITEM',
  FETCH_ANCESTERS: 'FETCH_ANCESTERS',
  FETCH_ITEM_DETAILS: 'FETCH_ITEM_DETAILS',
  UPDATE_DRIVE_ITEM: 'UPDATE_DRIVE_ITEM',
  SEARCH_FILES: 'SEARCH_FILES',
  FETCH_DRIVE_ITEM_DETAILS: 'FETCH_DRIVE_ITEM_DETAILS'
};

export const ttuTypes = {
  SHOW_TTU: 'SHOW_TTU',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  POST_RESPONSE: 'POST_RESPONSE',
  HIDE_TTU_WIDGET: 'HIDE_TTU_WIDGET',
  SHOW_TTU_CURTAIN: 'SHOW_TTU_CURTAIN'
};

export const pageInfoTypes = {
  SET_PAGE_INFO: 'SET_PAGE_INFO',
  SET_LPS: 'SET_LPS'
};

export const practiceSessionTypes = {
  FETCH_PRACTICE_TOPOLOGIES: 'FETCH_PRACTICE_TOPOLOGIES',
  FETCH_LEARNER_LEVEL_DETAILS: 'FETCH_LEARNER_LEVEL_DETAILS',
  FETCH_PRACTICE_SESSION: 'FETCH_PRACTICE_SESSION',
  CREATE_PRACTICE_SESSION: 'CREATE_PRACTICE_SESSION',
  FINISH_PRACTICE_SESSION: 'FINISH_PRACTICE_SESSION',
  FINISH_PRACTICE_QUESTION_REVIEW: 'FINISH_PRACTICE_QUESTION_REVIEW',
  SUBMIT_PRACTICE_SESSION_ANSWER: 'SUBMIT_PRACTICE_SESSION_ANSWER',
  GET_NEXT_PRACTICE_QUESTION: 'GET_NEXT_PRACTICE_QUESTION',
  SET_SELECTED_PRACTICE: 'SET_SELECTED_PRACTICE',
  SET_PRACTICE_ANSWERS: 'SET_PRACTICE_ANSWERS',
  SET_PRACTICE_QUESTION_COUNT: 'SET_PRACTICE_QUESTION_COUNT',
  SET_PRACTICE_SEEN_HINT: 'SET_PRACTICE_SEEN_HINT',
  SETUP_NEXT_PRACTICE_QUESTION: 'SETUP_NEXT_PRACTICE_QUESTION',
  RESET_PRACTICE_SESSION: 'RESET_PRACTICE_SESSION'
};
